<script setup lang="ts">
import type { IWidgetFaqPageBanner } from './types'

const props = defineProps<IWidgetFaqPageBanner>()
</script>

<template>
  <section class="rounded-lg bg-blue-50 p-6 md:p-6">
    <div class="flex w-full flex-col items-center text-center">
      <Heading tag="h3" class="h5 mb-2 !leading-5">{{ $t(props.heading) }}</Heading>
      <p class="text-sm md:leading-4">{{ $t(props.text) }}</p>
      <Button as-child class="mt-6">
        <NuxtLinkLocale :to="props.linkUrl">{{ $t(props.linkText) }}</NuxtLinkLocale>
      </Button>
    </div>
  </section>
</template>
